import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

// Corrected: Changed prop from 'isOpen' to 'open' to match what is being passed
const ZillowModal = ({ isOpen, onClose, propertyAddress, zillowUrl }) => {
  return (
    // Corrected: Pass the 'open' prop to the 'show' prop of the Transition component
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 flex justify-between items-center"
                >
                  <div className="flex items-center">
                    <svg
                      viewBox="0 0 36 36"
                      className="h-6 w-6 mr-2"
                      fill="#006AFF"
                    >
                      <path d="M13.84 26.3a.5.5 0 0 1 0-.54c.05-.1.13-.15.23-.15h1.18V13.78h-1.24c-.1 0-.2-.07-.24-.16s-.05-.2 0-.3l5.28-7.2v-.02c.05-.1.15-.13.24-.13.1 0 .18.05.23.13v.02l5.28 7.2c.05.1.06.2.01.3s-.14.16-.24.16h-1.03v11.83h1.04c.1 0 .18.06.23.15a.3.3 0 0 1 0 .54L18 33l-4.16-6.7z"></path>
                    </svg>
                    <span>Zillow Property Details - {propertyAddress}</span>
                  </div>
                  <button
                    type="button"
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={onClose}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </Dialog.Title>
                <div className="mt-4 h-[600px] border border-gray-200 rounded-lg overflow-hidden">
                  <iframe
                    src={zillowUrl}
                    title={`Zillow Property - ${propertyAddress}`}
                    className="w-full h-full"
                    style={{ border: "none" }}
                  />
                </div>
                <div className="mt-4 flex justify-end">
                  <a
                    href={zillowUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-3"
                  >
                    Open in New Tab
                  </a>
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#96ffa8]"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ZillowModal;